import { render, staticRenderFns } from "./GovExecutive.vue?vue&type=template&id=653e5e84&scoped=true"
import script from "./GovExecutive.vue?vue&type=script&lang=js"
export * from "./GovExecutive.vue?vue&type=script&lang=js"
import style0 from "./GovExecutive.vue?vue&type=style&index=0&id=653e5e84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653e5e84",
  null
  
)

export default component.exports